/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface UnreadCommentSummary { 
    totalUnreadComments: number;
}
export const UnreadCommentSummary_totalUnreadComments_Validators: ValidatorFn[] =
    [  Validators.required, ];


